import React from "react";
import { Link } from "react-router-dom";

import "../masterMaintenance/extraPageStyles.css";

const busUserDashboardButtons = [
  {
    name: "バスコース一覧",
    path: "/admin/bus/courses",
    icon: "fas fa-tachometer-alt",
  },
  {
    name: "バスコース詳細",
    path: "/admin/bus/course-details",
    icon: "fas fa-tachometer-alt",
  },
  {
    name: "バススケジュール",
    path: "/admin/bus/schedules-v2",
    icon: "fas fa-tachometer-alt",
  },
  {
    name: "バス一覧",
    path: "/admin/bus/buses",
    icon: "fas fa-tachometer-alt",
  },
  {
    name: "乗車名簿",
    path: "/admin/bus/riding-list",
    icon: "fas fa-tachometer-alt",
  },
];

function BusDashboard() {
  return (
    <div className="p-3">
      <p className="headline">バス管理機能一覧</p>
      <div className="btn-container col-md-4 col-sm-12">
        {busUserDashboardButtons.map(button => (
          <Link to={button.path}>
            <button className="dash-btn">{button.name}</button>
          </Link>
        ))}
      </div>
    </div>
  );
}

export default BusDashboard;
